import { Route, Routes } from 'react-router-dom';
// eslint-disable-next-line max-len
import * as permissionKind from '../../../../shared/permissions';
// eslint-disable-next-line max-len
import { type StandardApplicationEntrypointContextDataFragment } from '../../../api/fragments/StandardApplicationEntrypointContextData';
import hasPermissions from '../../../utilities/hasPermissions';
import withPrivateAccess from '../../../utilities/withPrivateAccess';
import NotFoundPage from '../NotFoundPage';
import CarDetailsPage from './CarDetailsPage';
import CarListingPage from './CarListingPage';
import ComparisonPage from './ComparisonPage';
import Journey from './Journey';
import ThankYouPage from './ThankYou';

export type PrivateAccessEntrypointProps = {
    endpoint: StandardApplicationEntrypointContextDataFragment;
};

const PrivateAccessEntrypoint = ({ endpoint }: PrivateAccessEntrypointProps) => {
    if (!hasPermissions(endpoint.applicationModule.permissions, [permissionKind.createApplication])) {
        return <NotFoundPage />;
    }

    return (
        <Routes>
            <Route key="list" element={<CarListingPage endpoint={endpoint} />} path="" />
            <Route key="comparison" element={<ComparisonPage endpoint={endpoint} />} path="comparison" />
            <Route key="carDetails" element={<CarDetailsPage endpoint={endpoint} />} path="details/:variantId" />
            <Route key="apply" element={<Journey endpoint={endpoint} />} path="apply" />
            <Route key="thankyou" element={<ThankYouPage />} path="thankyou" />
            <Route key="404" element={<NotFoundPage />} path="*" />
        </Routes>
    );
};

export default withPrivateAccess(PrivateAccessEntrypoint);
